import React from "react"
import { TemplateCatalogueItem } from "types/template.types"
import { splitKeyword, templatePeek, templateTags } from "./templateText"

interface TemplateCardProps {
  item: TemplateCatalogueItem
  /** The card shown in the preview pane */
  selected: boolean
  onSelect: (item: TemplateCatalogueItem) => void
  /** Double-click goes straight to "Use template" */
  onUse: (item: TemplateCatalogueItem) => void
}

/**
 * One gallery card: a peek of the questionnaire text, the label, the
 * description and the feature tags.
 *
 * @param props - The component props
 * @returns The card
 */
const TemplateCard: React.FC<TemplateCardProps> = ({
  item,
  selected,
  onSelect,
  onUse,
}) => {
  const tags = templateTags(item.merge)
  return (
    <button
      type="button"
      className={`tpl-card${selected ? " tpl-card--on" : ""}`}
      aria-pressed={selected}
      onClick={() => onSelect(item)}
      onDoubleClick={() => onUse(item)}
    >
      <div className="tpl-card-peek" aria-hidden>
        {templatePeek(item.merge).map((line, i) => {
          const { keyword, rest } = splitKeyword(line.trim())
          return (
            <div key={i} className="tpl-card-peek-line">
              {keyword && <b>{keyword}</b>}
              {rest}
            </div>
          )
        })}
      </div>
      <div className="tpl-card-body">
        <h4 className="tpl-card-title">{item.label}</h4>
        {item.description && (
          <p className="tpl-card-desc">{item.description}</p>
        )}
        {tags.length > 0 && (
          <div className="tpl-tags">
            {tags.map((tag) => (
              <span key={tag} className="tpl-tag">
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </button>
  )
}

export default TemplateCard
